/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preferred/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoAction from './NoAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import YesAction from './YesAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Preferred({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CreateIteroScanRequest/Content/Content/Step/Account/Content/Preferred"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let accountSettingsPreferredAccountNameValueData = fromData.useDataValue({ viewPath,
context: 'account_settings',
path: 'preferred_account.name',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 marginBottom={dtSpaceXs}
 text="Do you want to continue with the preferred account?"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="account_settings.preferred_account.name"
 text={accountSettingsPreferredAccountNameValueData}
 size="large"
 weight="bold"
/>
<div
  data-testid="Preferred.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-PgPVe': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<NoAction
  viewPath={`${viewPath}/NoAction`}
/>
<YesAction
  viewPath={`${viewPath}/YesAction`}
/>
</div>
{children}
</React.Fragment>)
}